<template>
  <div class="video__container">
    <VimeoPlayer class="video video--vimeo"
                 ref="player"
                 :video-id="videoId"
                 :controls="controls"
                 :autoplay="autoplay"
                 :loop="looping" />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { vueVimeoPlayer as VimeoPlayer } from 'vue-vimeo-player'
import {useI18n} from "#imports";
const { locale } = useI18n()
const props = defineProps({
  content: Object
})
let videoId
if(props.content.video) {
	videoId = computed(() => locale.value === 'en' ? props.content.video.en : props.content.video.jp)
}
console.log('videoId is ', videoId.value)
const looping = ref(props.content.isLooping)
const autoplay = ref(props.content.isAutoplay)
const controls = ref(props.content.hasControls)
</script>

<style lang="scss">
.video__container {
  display: block;
	margin: 0 0 3rem 0;
  width: 100%;
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;

  .video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
